import { Button } from '@atd/rui-base.mui.button'
import { Checkbox } from '@atd/rui-base.mui.checkbox'
import { FormControlLabel } from '@atd/rui-base.mui.form-control-label'
import React from 'react'
import ValidatedTextField from '../commonComponents/validatedTextField'
import axios from '../lib/axios'

export default class LiveView extends React.Component {
    state = {
        blob: {},
        loading: false,
        useSinceTimestamp: true,
        ownerPartyId: '',
        deviceId: '',
        since: '1970-01-01T00:00:01.000Z',
        ownerPartyIdError: '',
        deviceIdError: '',
        sinceError: '',
    }

    validate = () => {
        const { ownerPartyId, deviceId, since, useSinceTimestamp } = this.state
        let valid = true
        const errors = { ownerPartyIdError: '', deviceIdError: '', sinceError: '' }

        if (!/^\d+$/.test(ownerPartyId.trim())) {
            errors.ownerPartyIdError = 'Must be a positive integer'
            valid = false
        }

        if (!/^\d+$/.test(deviceId.trim())) {
            errors.deviceIdError = 'Must be a positive integer'
            valid = false
        }

        if (useSinceTimestamp) {
            const ts = new Date(since).getTime()
            if (isNaN(ts) || ts < 1) {
                errors.sinceError = 'Must be at least 1 ms past epoch (after 1970-01-01T00:00:00.000Z)'
                valid = false
            }
        }

        this.setState(errors)

        return valid
    }

    submitRequest = () => {
        if (!this.validate()) return

        const { ownerPartyId, deviceId, since, useSinceTimestamp } = this.state
        const body = {
            devices: [{ deviceId: parseInt(deviceId, 10), ownerPartyId: parseInt(ownerPartyId, 10) }],
            ...(useSinceTimestamp && { since }),
        }

        this.setState({ loading: true })

        return axios.post('/jobs/net-api/jobsync/by-device', body)
            .then(res => res.data)
            .then(json => {
                this.setState({
                    loading: false,
                    blob: { ...json },
                    since: json.timestamp || this.state.since,
                })
            })
            .catch(err => {
                this.setState({ loading: false, blob: { status: err.response?.status, body: err.response?.data } })
            })
    }

    render() {
        const { useSinceTimestamp, ownerPartyId, deviceId, since, blob, loading,
            ownerPartyIdError, deviceIdError, sinceError } = this.state

        return (
            <div>
                <div style={{ width: '100%', maxWidth: 700, margin: 'auto' }}>
                    <ValidatedTextField
                        label="Device Owner Party Id"
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        placeholder="Ex: 7557"
                        onChange={(e) => this.setState({ ownerPartyId: e.target.value })}
                        value={ownerPartyId}
                        name="ownerPartyIdTextbox"
                        errorText={ownerPartyIdError}
                    />
                    <ValidatedTextField
                        label="Device Id"
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        placeholder="Ex: 12345"
                        onChange={(e) => this.setState({ deviceId: e.target.value })}
                        value={deviceId}
                        name="deviceIdTextbox"
                        errorText={deviceIdError}
                    />
                    <FormControlLabel
                        label="Use since timestamp"
                        control={
                            <Checkbox
                                checked={useSinceTimestamp}
                                onChange={() => this.setState({ useSinceTimestamp: !useSinceTimestamp })}
                                name="sinceTimestampCheckbox"
                            />
                        }
                    />
                    <ValidatedTextField
                        label="Last Event Timestamp"
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        placeholder="Ex: 1970-01-01T00:00:01.00Z"
                        onChange={(e) => this.setState({ since: e.target.value })}
                        value={since}
                        name="sinceTextbox"
                        disabled={!useSinceTimestamp}
                        errorText={sinceError}
                    />
                    <Button variant="contained"
                        onClick={this.submitRequest}
                        disabled={loading}
                        name="submitButton">{'Send'}</Button>
                    <pre>
                        {JSON.stringify(blob, null, 2)}
                    </pre>
                </div>
            </div>
        )
    }
}
